import {useAppSelector} from "@Hooks/selector/useAppSelector";

/**
 * Returns isMobile boolean from page state
 */
export default function useIsMobile(): boolean {
    return useAppSelector((state) => state?.page.isMobile)
}